function IncompleteURL(){
    return (<div className="form-group text-center" >
    <div className="alert alert-info">
        <div><i className="fas fa-exclamation-triangle fa-3x"></i></div>
        To reveal your secret use the complete URL, which contains the required secret ID and password.
    </div>
</div>);
}

export default IncompleteURL;